import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "CajaChicaPage",
    data() {
        let ss = new MainService();
        return {
            msg: "CajaChicaPage",
            ss: ss,
            ajax: {
                "url": ss.indexCajaChica(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Reparticion', name: 'r.Reparticion', title: 'Reparticion' },
                { data: 'Subcuenta', name: 'su.Subcuenta', title: 'Subcuenta' },
                { data: 'ComprobanteContable', name: 'cc.ComprobanteContable', title: 'Glosa' },
                { data: 'Monto', name: 'cc.Monto', title: 'Monto' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rutaApp: process.env.VUE_APP_MAIN_SERVICE,
            cajachicas: [],
            cajachica: {},
            isLoading: false,
            errorBag: {},
            subcuentas: [],
            searchSubcuenta: "",
            selectedSubCuenta:null,
            reparticiones: [],
            searchReparticion: "",
            selectedReparticion: null,
            fuenteFinancieras: [],
            archivo: {},
        };
    },
    methods: {
        newCajaChica() {
            this.cajachica = {};
            this.$refs['frm-cajachica'].show();
        },
        showCajaChica(id) {
            this.isLoading=true;
            this.ss.showCajaChica(id).then(
                (result) => {
                    let response = result.data;
                    this.cajachica = response.data;
                    this.$refs['view-cajachica'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editCajaChica() {
            this.$refs['frm-cajachica'].show();
            this.$refs['view-cajachica'].hide();
        },
        cancelCajaChica() {
            if (this.cajachica.id) {
                this.$refs['view-cajachica'].show();
            }
            this.$refs['frm-cajachica'].hide();
        },
        saveCajaChica() {
            this.ss.storeCajaChica(this.cajachica).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-cajachica'].hide();
                    this.$refs['datatable-cajachica'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteCajaChica() {
            this.$swal({
                title: "¿Estás seguro que deseas eliminar?",
                text: "¿Esta acción es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyCajaChica(this.cajachica)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-cajachica'].hide();
                                this.$refs['datatable-cajachica'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-CajaChica').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showCajaChica(data);
            });
        },
        printRecibo() {
            console.log("id cajachica",this.cajachica.id);
            this.ss.printRecibo(this.cajachica.id)
                .then(
                    result => {
                        let response = result.data;
                        var urlFile = response.data;
                        var dir = this.rutaApp + urlFile.url;
                        window.open(dir);
                    })
                .catch(error => {
                    console.log(error);
                    this.isLoading = false;
                })

        },
    },
    watch: {
        searchSubcuenta(q) {
            this.ss.select2Subcuenta(q).then((res) => {
                console.log("",res);
                if (res.data.success) {
                    this.subcuentas = res.data.items;
                } else {
                    this.subcuentas = [];
                }
            })
        },
        searchReparticion(q) {
            this.ss.select2Reparticion(q).then((res) => {
                console.log("",res);
                if (res.data.success) {
                   
                    this.reparticiones = res.data.items;
                
                } else {
                    this.reparticiones = [];
                }
            })
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
